module.exports = __webpack_public_path__ + "img/blocks-2.54fd09f1.png";